import { render, staticRenderFns } from "./TargetingLastVisitedUrl.vue?vue&type=template&id=a0e517e6&"
import script from "./TargetingLastVisitedUrl.vue?vue&type=script&lang=js&"
export * from "./TargetingLastVisitedUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports